import { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { VerifyEmailImage } from "shared/assets/svg/VerifyEmailImage";
import { Button } from "shared/components/ui/button";
import { useToast } from "shared/components/ui/use-toast";
import { auth } from "shared/config/firebase";
import { AuthService } from "shared/services/AuthService";
import { EmailVerificationService } from "shared/services/EmailVerificationService";

export const VerifyEmailPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { toast } = useToast();

  const email = auth.currentUser?.email;

  const resendEmail = () => {
    EmailVerificationService.sendEmailVerification(
      "https://eviva.streetbeat.com",
    ).then(() => {
      toast({
        title: t("global.success"),
        description: t("verifyEmail.emailResent"),
      });
    });
  };

  useEffect(() => {
    let refreshAuthTimeout: NodeJS.Timeout | null = null;

    const fetchUserStatus = async () => {
      await auth.currentUser?.reload();
      const user = auth.currentUser;
      if (!user?.emailVerified) {
        auth.currentUser?.reload();
        refreshAuthTimeout = setTimeout(fetchUserStatus, 2000);
      } else {
        navigate("/");
      }
    };

    fetchUserStatus();

    return () => {
      if (refreshAuthTimeout) {
        clearTimeout(refreshAuthTimeout);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  auth.currentUser?.reload();

  return (
    <div className="grid h-full place-items-center">
      <div className="max-w-2xl">
        <div className="mb-12 flex justify-center">
          <VerifyEmailImage className="w-[192px]" />
        </div>
        <div className="mb-2 text-xl font-semibold">
          {t("verifyEmail.title")}
        </div>
        <Trans i18nKey="verifyEmail.emailSent" values={{ email }}>
          <span className="ml-1 font-semibold"></span>
        </Trans>
        <div className="mt-4">
          <Trans i18nKey="verifyEmail.resend">
            <span
              className="ml-1 cursor-pointer font-semibold underline"
              onClick={resendEmail}
            ></span>
          </Trans>
        </div>
        <div className="mt-10 flex justify-between">
          <Button onClick={() => AuthService.signOut()} variant="outline">
            {t("global.logout")}
          </Button>
          <Button
            disabled={!auth.currentUser?.emailVerified}
            onClick={() => navigate("/")}
          >
            {t("global.next")}
          </Button>
        </div>
      </div>
    </div>
  );
};
